module.exports = ['$scope', '$stateParams', 'curriculumManager', 'ngMeta', '$state', '$q', 'bibContentManager', 'settings',
  function ($scope, $stateParams, curriculumManager, ngMeta, $state, $q, bibContentManager, settings) {
    'use strict';
    $scope.toggle = {
      contents: {
        open: false,
        show: false,
        toggle: function () {
          Object.keys($scope.toggle.items.content1).forEach(function (i) {
            $scope.toggle.items.content1[i] = !$scope.toggle.contents.open;
          });
          $scope.toggle.contents.open = !$scope.toggle.contents.open;
          if (!$scope.toggle.contents.open) {
            Object.keys($scope.toggle.items.leerlijn).forEach(function (i) {
              $scope.toggle.items.leerlijn[i] = false;
            });
            $scope.toggle.leerlijn.open = false;
          }
        }
      },
      leerlijn: {
        open: false,
        show: false,
        showSpecificForAn: false,
        toggle: function () {
          if (!$scope.toggle.leerlijn.open) {
            Object.keys($scope.toggle.items.content1).forEach(function (i) {
              $scope.toggle.items.content1[i] = true;
            });
          }
          $scope.toggle.contents.open = true;
          Object.keys($scope.toggle.items.leerlijn).forEach(function (i) {
            $scope.toggle.items.leerlijn[i] = !$scope.toggle.leerlijn.open;
          });
          $scope.toggle.leerlijn.open = !$scope.toggle.leerlijn.open;
        }
      },
      items: {
        content1: [],
        leerlijn: []
      }
    };

    $scope.open = function (item) {

      var closeUnder = function (item) {
        if(item.content2s) {
          item.content2s.forEach(function (content2) {
            $scope.toggle.items.leerlijn[content2.key] = false;
          });
        }
      };

      if (!angular.isUndefined(item.leerlijn)) {
        if ($scope.toggle.items.leerlijn[item.key]) {
          closeUnder(item);
        }
        $scope.toggle.items.leerlijn[item.key] = !$scope.toggle.items.leerlijn[item.key];
        $scope.toggle.leerlijn.open = false;
        Object.keys($scope.toggle.items.leerlijn).forEach(function (i) {
          if ($scope.toggle.items.leerlijn[i]) {
            $scope.toggle.leerlijn.open = true;
          }
        });
      } else if (item.content2s.length > 0) {
        if ($scope.toggle.items.content1[item.key]) {
          closeUnder(item);
        }
        $scope.toggle.items.content1[item.key] = !$scope.toggle.items.content1[item.key];
        $scope.toggle.contents.open = false;
        Object.keys($scope.toggle.items.content1).forEach(function (i) {
          if ($scope.toggle.items.content1[i]) {
            $scope.toggle.contents.open = true;
          }
        });

      }
    };

    $scope.isOpen = function (key) {
      return $scope.toggle.items.content1[key] || $scope.toggle.items.leerlijn[key];
    };

    curriculumManager.getFieldById($stateParams.fieldKey).then(function (field) {
      $scope.field = field;
    });

    curriculumManager.getThemeByIdentifiers($stateParams.fieldKey, $stateParams.themeKey).then(function (theme) {
      $scope.theme = theme;
      curriculumManager.getNext(theme).then(function (nextTheme) {
        $scope.nextTheme = nextTheme;
      });
    });

    function shouldContentBeOpened(goal) {
      if ($stateParams.contentKey) {
        let content = goal.leerlijn.developmentSteps.find((developmentStep) => {
          return developmentStep.key === $stateParams.contentKey;
        });
        return !!content;
      }
      return false;
    }

    function openContainer(goal) {
      if ($stateParams.containerKey) {
        let container = goal.contentGroups[0].content1s.find((content) => {
          return content.key === $stateParams.containerKey;
        });
        if(!container) {
          let subContainer;
          goal.contentGroups[0].content1s.forEach((content) => {
            const found = content.content2s.find((content2) => content2.key === $stateParams.containerKey);
            if(found) {
              container = content;
              subContainer = found;
            }
          });
          if(container) {
            $scope.open(container);
            $scope.open(subContainer);
          }
        } else {
          $scope.open(container);
        }
      }
    }

    function loadGoal(goalKey) {
      $scope.toggle.contents.open = false;
      $scope.toggle.contents.show = false;
      $scope.toggle.leerlijn.open = false;
      $scope.toggle.leerlijn.show = false;
      $scope.toggle.items = {
        content1: [],
        leerlijn: []
      };


      curriculumManager.getGoalByIdentifiers($stateParams.fieldKey, $stateParams.themeKey, goalKey)
        .then(function (goal) {

          if (typeof goal === 'undefined') {
            $state.go('notFound', {}, {location: false});
          }
          $scope.goal = goal;
          ngMeta.setTitle(goal.code + ' - ' + goal.theme.title);
          ngMeta.setTag('description', goal.title);
          ngMeta.setTag('image', goal.theme.coverUrl);

          $scope.nextGoal = function () {
            curriculumManager.getNext(goal).then(function (nextGoal) {
              //loadGoal(nextGoal.identifiers[0]);
              $state.go('leerinhoud.goal', {goalKey: nextGoal.identifiers[0]}, {notify: false, location: 'replace'});
            });
          };

          $scope.prevGoal = function () {
            curriculumManager.getPrev(goal).then(function (prevGoal) {
              //loadGoal(prevGoal.identifiers[0]);
              $state.go('leerinhoud.goal', {goalKey: prevGoal.identifiers[0]}, {notify: false, location: 'replace'});
            });
          };

          if ($scope.goal.contentGroups[0]) {
            $scope.goal.contentGroups[0].content1s.forEach(function (content) {
              content.content2s.forEach(function (content2) {
                $scope.toggle.items.leerlijn[content2.key] = false;
                $scope.toggle.contents.show = true;
                if (content2.leerlijn) {
                  $scope.toggle.leerlijn.show = true;
                }
              });
              if (content.leerlijn) {
                $scope.toggle.items.leerlijn[content.key] = false;
                $scope.toggle.leerlijn.show = true;
              } else {
                $scope.toggle.items.content1[content.key] = false;
              }
            });
            openContainer(goal);
          }
          $scope.goal.leerlijn.showClustersUnder2YearsAnd6Month = shouldContentBeOpened(goal);
        });
    }
    loadGoal($stateParams.goalKey);

  }
];



// WEBPACK FOOTER //
// ./web/js/screen/leerinhoud/goal/leerinhoudGoalController.js